import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';

var DEFAULT_COLOUR = 'primary';
var DEFAULT_COLOUR_VARIANT = 'main';
function getInkColour(theme) {
  var _theme$colours$ink$co;
  var colourVariant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "".concat(DEFAULT_COLOUR, ".").concat(DEFAULT_COLOUR_VARIANT);
  var _colourVariant$split = colourVariant.split('.'),
    _colourVariant$split2 = _slicedToArray(_colourVariant$split, 2),
    _colourVariant$split3 = _colourVariant$split2[0],
    colour = _colourVariant$split3 === void 0 ? DEFAULT_COLOUR : _colourVariant$split3,
    _colourVariant$split4 = _colourVariant$split2[1],
    variant = _colourVariant$split4 === void 0 ? DEFAULT_COLOUR_VARIANT : _colourVariant$split4;
  return (_theme$colours$ink$co = theme.colours.ink[colour]) === null || _theme$colours$ink$co === void 0 ? void 0 : _theme$colours$ink$co[variant];
}

export { getInkColour as default };
//# sourceMappingURL=getInkColour.js.map
